import React from 'react';
import { Switch } from 'react-router-dom';

import LoginContainer from '../containers/Login';

import CitiesPage from '../containers/CitiesPage';
import CountriesPage from '../containers/CountriesPage';
import DashboardPage from '../containers/DashboardPage';
import DebtComponent from '../containers/DebtPage';
import GroupSinlePage from '../containers/GroupSinlePage';
import GroupSinlePageHW from '../containers/GroupSinlePageHw';
import GroupsPage from '../containers/GroupsPage';
import HWSettings from '../containers/HWSettings';
import OfficesPage from '../containers/OfficesPage';
import PaymentsPage from '../containers/PaymentsPage';
import PlannerPage from '../containers/PlannerPage';
import RegionsPage from '../containers/RegionsPage';
import RelocatePage from '../containers/RelocatePage';
import RequestsPage from '../containers/RequestsPage';
import RolesPage from '../containers/RolesPage';
import SalesPage from '../containers/SalesPage';
import ServicesPage from '../containers/ServicesPage';
import StatisticsPage from '../containers/StatisticsPage';
import StudentsPage from '../containers/StudentsPage';
import UsersPage from '../containers/UsersPage';
import AnalyticsPage from './../containers/AnalyticsPage';
import BooksPage from './../containers/BooksPage';
import FinancePage from './../containers/FinancePage';
import HelpPage from './../containers/HelpPage';
import Journal from './../containers/JournalPage';
import OlympiadPage from './../containers/OlympiadPage';
import ProtectedLoginRoute from './ProtectedLoginRoute';
import ProtectedRedirectRoute from './ProtectedRedirectRoute';
import ProtectedRoute from './ProtectedRoute';

import ARPage from '../containers/ARPage';
import ExercisePage from '../containers/ExercisePage';
import FranchBooksPage from '../containers/FranchBooksPage';
import MyTemplates from '../containers/MyTemplates';

import GroupHistoryHw from '../components/HwHistory/GroupHistoryHw';
import GroupHistoryHwDate from '../components/HwHistory/GroupHistoryHwDate';
import GroupHistoryHwSettings from '../components/HwHistory/GroupHistoryHwSettings';
import GroupHistoryHwUsers from '../components/HwHistory/GroupHistoryHwUsers';
import BankBossPage from '../containers/BankBossPage';
import BankFranchPage from '../containers/BankFranchPage';
import BankStudentsPage from '../containers/BankStudentsPage';
import BankTeachersPage from '../containers/BankTeachersPage';
import CreateQuizPage from '../containers/CreateQuizPage';
import MyTemplatesPage from '../containers/MyTemplatesPage';
import NewsPage from '../containers/NewsPage';
import { QuizPage } from '../containers/QuizPage';
import { QuizSingleStatisticPage } from '../containers/QuizSingleStatisticPage';
import { QuizStatisticPage } from '../containers/QuizStatisticPage';
import { QuizTeacherStatisticPage } from '../containers/QuizTeacherStatisticPage';
import ShopPage from '../containers/ShopPage';
import StudentBankSorobanPage from '../containers/StudentBankSorobanPage';
import UserBankSorobanPage from '../containers/UserBankSorobanPage';
import VillageSettingsPage from '../containers/VillageSettingsPage';
import OlympiadParticipants from '../containers/OlympiadPage/OlympiadParticipants';
import HomeworkCyclesStatsPage from '../containers/HomeworkCyclesStatsPage';
import TextbookAssignmentHistoryPage from '../containers/TextbookAssignmentHistoryPage';
import PromoVisitsPage from '../containers/PromoVisitsPage';

export class RootRoute extends React.Component {
    render() {
        return (
            <Switch>
                <ProtectedLoginRoute path="/login" component={LoginContainer} />
                <ProtectedRedirectRoute exact path="/" />

                <ProtectedRoute exact path="/dashboard" component={DashboardPage} />
                <ProtectedRoute exact path="/dashboard/hidden" component={DashboardPage} />
                <ProtectedRoute exact path="/users" component={UsersPage} />
                <ProtectedRoute exact path="/users/bank/:id/:role" component={UserBankSorobanPage} />
                <ProtectedRoute exact path="/cities" component={CitiesPage} />
                <ProtectedRoute exact path="/requests" component={RequestsPage} />
                <ProtectedRoute exact path="/groups" component={GroupsPage} />
                <ProtectedRoute exact path="/groups/:id" component={GroupSinlePage} />
                <ProtectedRoute exact path="/groups/:id/hw/:date" component={GroupSinlePageHW} />
                <ProtectedRoute exact path="/groups/:groupId/hwHistory" component={GroupHistoryHw} />
                <ProtectedRoute exact path="/groups/:groupId/hwHistory/:usersId" component={GroupHistoryHwUsers} />
                <ProtectedRoute
                    exact
                    path="/groups/:groupId/hwHistory/:usersId/date/:studentId"
                    component={GroupHistoryHwDate}
                />
                <ProtectedRoute
                    exact
                    path="/groups/:groupId/hwHistory/:usersId/date/:studentId/settings/:settingsId"
                    component={GroupHistoryHwSettings}
                />
                <ProtectedRoute exact path="/planner" component={PlannerPage} />
                <ProtectedRoute exact path="/countries" component={CountriesPage} />
                <ProtectedRoute exact path="/offices" component={OfficesPage} />
                <ProtectedRoute exact path="/quizzes" component={QuizPage} />
                <ProtectedRoute exact path="/quizzesStatisticFranch" component={QuizStatisticPage} />
                <ProtectedRoute exact path="/quizzesStatistic" component={QuizTeacherStatisticPage} />

                <ProtectedRoute exact path="/regions" component={RegionsPage} />
                <ProtectedRoute exact path="/roles" component={RolesPage} />
                <ProtectedRoute exact path="/finances_analitics" component={FinancePage} />

                <ProtectedRoute exact path="/book_generate_codes" component={BooksPage} />
                <ProtectedRoute exact path="/statistics" component={StatisticsPage} />
                <ProtectedRoute exact path="/students" component={StudentsPage} />
                <ProtectedRoute exact path="/students/bank/:id/:role" component={StudentBankSorobanPage} />
                <ProtectedRoute exact path="/dashboard/balances/students" component={BankStudentsPage} />
                <ProtectedRoute exact path="/dashboard/balances/teachers" component={BankTeachersPage} />
                <ProtectedRoute exact path="/dashboard/balances/franch" component={BankFranchPage} />
                <ProtectedRoute exact path="/dashboard/balances/boss" component={BankBossPage} />
                <ProtectedRoute exact path="/books-stat" component={FranchBooksPage} />

                <ProtectedRoute exact path="/students/:type" component={StudentsPage} />

                <ProtectedRoute exact path="/payments" component={PaymentsPage} />
                <ProtectedRoute exact path="/services" component={ServicesPage} />
                <ProtectedRoute exact path="/sales" component={SalesPage} />
                <ProtectedRoute exact path="/HWSettings" component={HWSettings} />

                <ProtectedRoute exact path="/exercise" component={ExercisePage} />
                <ProtectedRoute exact path="/ar" component={ARPage} />
                <ProtectedRoute exact path="/journal" component={Journal} />
                <ProtectedRoute exact path="/relocate" component={RelocatePage} />
                <ProtectedRoute exact path="/debt" component={DebtComponent} />
                <ProtectedRoute exact path="/analytics" component={AnalyticsPage} />
                <ProtectedRoute exact path="/olympiad" component={OlympiadPage} />
                <ProtectedRoute exact path="/help" component={HelpPage} />
                <ProtectedRoute exact path="/templates" component={MyTemplates} />
                <ProtectedRoute exact path="/shop" component={ShopPage} />
                <ProtectedRoute exact path="/template" component={MyTemplatesPage} />
                <ProtectedRoute
                    exact
                    path="/quizzesStatisticFranch/teacher/:teacher_id"
                    component={QuizTeacherStatisticPage}
                />

                <ProtectedRoute
                    exact
                    path="/quizzesStatisticFranch/teacher/quiz/:id"
                    component={QuizSingleStatisticPage}
                />
                <ProtectedRoute exact path="/quizzesStatistic/teacher/quiz/:id" component={QuizSingleStatisticPage} />
                <ProtectedRoute exact path="/news" component={NewsPage} />
                <ProtectedRoute exact path="/quiz_create" component={CreateQuizPage} />
                <ProtectedRoute exact path="/dashboard/balances/villageSettings" component={VillageSettingsPage} />
                <ProtectedRoute exact path="/olympiad/:period" component={OlympiadParticipants} />
                <ProtectedRoute exact path="/students/hwCyclesStats/:student_id" component={HomeworkCyclesStatsPage} />
                <ProtectedRoute exact path="/groups/:id/hwCyclesStats/:student_id" component={HomeworkCyclesStatsPage} />
                <ProtectedRoute exact path="/students/textbookHistory/:student_id" component={TextbookAssignmentHistoryPage} />
                <ProtectedRoute exact path="/groups/:id/textbookHistory/:student_id" component={TextbookAssignmentHistoryPage} />
                <ProtectedRoute exact path="/groups/:id/promoVisits" component={PromoVisitsPage} />
            </Switch>
        );
    }
}
